import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "زخرفة النصوص - زخرفة الأسماء والنصوص بالعربي والإنجليزي";
const DESCRIPTION =
  "قم بإضفاء لمسة فريدة وجمالية على النصوص والأسماء الخاصة بك باللغة العربية أو الإنجليزية باستخدام أداة زخرفة النصوص. اختر من بين مجموعة واسعة من الأنماط، الخطوط، والرموز لتخصيص النصوص بسهولة. مثالية لزخرفة الأسماء والنصوص على وسائل التواصل الاجتماعي، المدونات، والتصاميم الجرافيكية.";
const KEYWORDS =
  "زخرفة النصوص, زخرفة اسماء, زخرفة الاسماء, اسماء مزخرفة, زخرفة اسم, كتابة مزخرفة, زخرفة الخطوط، تزيين النص، أنماط نصية، خطوط، رموز، تصميم نصوص، تزيين النصوص، تصميم جرافيكي، زخرفة بالعربية، زخرفة بالإنجليزية.";
const OG_URL = "https://do-calculate.com/calculator/ar/text-decorator/";
const flipTables = [
  {
    ا: "ا",
    ب: "ب",
    و: "و",
    ي: "يہ",
    ث: "ثہ",
    ت: "تہ",
    خ: "خہ",
    ج: "جہ",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہ",
    ش: "شہ",
    ص: "ص",
    غ: "غہ",
    ك: "كُہ",
    ف: "فُہ",
    م: "م",
    ل: "لہ",
    ن: "ن",
    ه: "ه",
    ح: "حہ",
    ع: "عہ",
    ق: "ق",
    ط: "طہ",
    ظ: "ظ",
    ى: "ي",
    1: "1",
    2: "2ً",
    3: "3ً",
    4: "4ً",
    5: "5ً",
    6: "6ً",
    7: "7َ",
    8: "8ً",
    9: "9ً",
    0: "0ً",
    a: "ä",
    b: "þ",
    c: "c",
    d: "ḑ",
    e: "ễ",
    f: "f",
    g: "g",
    h: "ħ",
    i: "ī",
    j: "Ĵ",
    k: "Ķ",
    l: "l",
    m: "m",
    n: "ٍñ",
    o: "o",
    p: "p",
    q: "q",
    r: "r",
    s: "ṩ",
    t: "Ť",
    u: "ú",
    v: "v",
    w: "‏w ",
    x: "x",
    y: "ÿ",
    z: "ź",
  },
  {
    ا: "أ",
    ب: "بہ",
    و: "و",
    ي: "يہ",
    ث: "ثہ",
    ت: "تہ",
    خ: "خہ",
    ج: "جہ",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہ",
    ش: "شہ",
    ص: "صہ",
    غ: "غہ",
    ك: "كہ",
    ف: "فہ",
    م: "مہ",
    ل: "ل",
    ن: "نہ",
    ه: "ه",
    ح: "حہ",
    ع: "عہ",
    ق: "قہ",
    ط: "طہ",
    ظ: "ظہ",
    ي: "يہ",
    a: "ặ",
    b: "ß",
    c: "c",
    d: "d",
    e: "ě",
    f: "f",
    g: "g",
    h: "ĥ",
    i: "í",
    j: "j",
    k: "k",
    l: "ł ",
    m: "ɱ",
    n: "ŋ",
    o: "ŏ",
    p: "p",
    q: "q",
    r: "ř",
    s: "ś",
    t: "ț",
    u: "u",
    v: "v",
    w: "w",
    x: "x",
    y: "ŷ",
    z: "ž",
    A: "ֻ",
    B: "ג",
    C: "Ͼ",
    D: "׀",
    E: "׃",
    F: "Ḟ",
    G: "Ḡ",
    H: "Ḥ",
    I: "ḭ",
    J: "J",
    K: "Ḳ",
    L: "Ɫ",
    M: "Ṃ",
    N: "Ṇ",
    O: "Ṓ",
    P: "Ᵽ",
    Q: "Q",
    R: "Ṝ",
    S: "Ṩ",
    T: "Ṫ",
    U: "Ṷ",
    V: "Ṿ",
    W: "Ẅ",
    X: "Ẍ",
    Y: "Ῡ",
    Z: "Ẓ",
  },
  {
    ا: "ا",
    ب: "بٰٰ",
    و: "و",
    ي: "يٰ",
    ث: "ثہٰـ",
    ت: "تہٰ",
    خ: "خ",
    ج: "ج",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہٰ",
    ش: "ش",
    ص: "صہٰ",
    ع: "ع",
    ك: "كہٰ",
    ف: "فہٰ",
    م: "م",
    ل: "لہٰ",
    ن: "ن",
    ه: "ه",
    ح: "حہٰ",
    غ: "غ",
    ق: "ق",
    ط: "طہٰ",
    ظ: "ظ",
    ى: "ي",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    0: "0",
    a: "Ꭿ ",
    b: "Ᏸ ",
    c: "Ꮸ",
    d: "Ꭰ",
    e: "Ꭼ",
    f: "Ꮀ",
    g: "Ꮆ",
    h: "Ꮋ",
    i: "Ꭵ",
    j: "Ꭻ",
    k: "Ꮶ",
    l: "Ꮮ",
    m: "Ꮇ",
    n: "Ꮑ",
    o: "Ꮻ",
    p: "Ꮲ",
    q: "Ꮕ",
    r: "Ꭱ",
    s: "Ꮪ",
    t: "Ꮏ",
    u: "Ꮜ",
    v: "Ꮙ",
    w: "Ꮤ",
    x: "X",
    y: "Ꮍ",
    z: "Ꮓ",
  },
  {
    ا: "آ",
    ب: "بَ",
    و: "وُ",
    ي: "ي",
    ث: "ث",
    ت: "ت",
    خ: "خـ",
    ج: "جٍ",
    د: "دِ",
    ذ: "ذَ",
    ز: "زْ",
    ر: "رٍ",
    س: "س",
    ش: "شُ",
    ص: "ص",
    غ: "غ",
    ك: "ڪ",
    ف: "فُ",
    م: "م",
    ل: "لُِ",
    ن: "ن",
    ه: "هـ",
    ح: "حٍ",
    ع: "عٍ",
    ق: "قٌ",
    ط: "طُ",
    ظ: "ظً",
    ى: "ﮯ",
    a: "a",
    b: "b",
    c: "ç",
    d: "ƌ̲̣̣̣̥",
    e: "e̲̣̥",
    f: "ƒ",
    g: "Ǧ̩̥",
    h: "h",
    i: "ɪ̣̝̇",
    j: "Ĵ",
    k: "k",
    l: "l",
    m: "m̥",
    n: "n̥̥̲̣̥",
    o: "ọ̥",
    p: "ٌ̥̥",
    q: "ợ",
    r: "ے̲̣̣̥",
    s: "ƨ",
    t: "ô̲̣̣̥",
    u: "u",
    v: "ُ̲̣̥",
    w: "‏",
    x: "x̲̣̣̣̥",
    y: "y̥",
    z: "z̲̣̥",
    1: "1̣̣̝̇̇",
    2: "2̲̣̣̣̥",
    3: "3̍̍̍̊",
    4: "4̩̥",
    5: "5̲̣̥",
    6: "6̥̥̲̣̥",
    7: "7̣̣̣̝̇̇̇",
    8: "8̣̝̇",
    9: "9̲̣̣̥",
    0: "0̲̣̣̥",
  },
  {
    ا: "آ",
    ب: "ب",
    و: "ۆ",
    ي: "يَ",
    ث: "ث",
    ت: "ت",
    خ: "خـ",
    ج: "جٍ",
    د: "دِ",
    ذ: "ڌ",
    ز: "ز",
    ر: "رٍ",
    س: "س",
    ش: "شُ",
    ص: "ص",
    غ: "غ",
    ك: "گ",
    ف: "فَ",
    م: "م",
    ل: "لُ",
    ن: "ن",
    ه: "ہ",
    ح: "حٍ",
    ع: "عٍ",
    ق: "ق",
    ط: "طُ",
    ظ: "ظً",
    ى: "ﮯ",
    a: "ᵃ",
    b: "ᵇ",
    c: "ᶜ",
    d: "ᵈ",
    e: "ᵉ",
    f: "ᶠ",
    g: "ᵍ",
    h: "ʰ",
    i: "ᶤ",
    j: "ʲ",
    k: "ᵏ",
    l: "ˡ",
    m: "ᵐ",
    n: "ᶰ",
    o: "ᵒ",
    p: "ᵖ",
    q: "ᵠ",
    r: "ʳ",
    s: "ˢ",
    t: "ᵗ",
    u: "ᵘ",
    v: "ᵛ",
    w: "ʷ",
    x: "ˣ",
    y: "ʸ",
    z: "ᶻ",
    1: "₁",
    2: "₂",
    3: "₃",
    4: "₄",
    5: "₅",
    6: "₆",
    7: "₇",
    8: "₈",
    9: "₉",
    0: "₀",
  },
  {
    ا: "ٵ̷ ",
    ب: "ب̷",
    و: "ۆ̷",
    ي: "ي̷",
    ث: "ث̷",
    ت: "ت̷",
    خ: "خ̷",
    ج: "ج̷",
    د: "د̷ِ",
    ذ: "ذ̷",
    ز: "ز̷",
    ر: "ر̷",
    س: "س̷",
    ش: "ش̷ُ",
    ص: "ص̷",
    غ: "غ̷",
    ك: "گ̷",
    ف: "ف̷َ",
    م: "م̷",
    ل: "ل̷",
    ن: "ن̷",
    ه: "ہ̷",
    ح: "ح̷",
    ع: "ع̷ٍ",
    ق: "ق̷",
    ط: "ط̷ُ",
    ظ: "ظ̷ً",
    ى: "ﮯ̷",
    a: "a̷",
    b: "b̷",
    c: "c̷",
    d: "d̷",
    e: "e̷",
    f: "f̷",
    g: "g̷",
    h: "h̷",
    i: "i̷",
    j: "j̷",
    k: "k̷",
    l: "l̷",
    m: "m̷",
    n: "n̷",
    o: "o̷",
    p: "p̷",
    q: "q̷",
    r: "r̷",
    s: "s̷",
    t: "t̷",
    u: "u̷",
    v: "v̷",
    w: "w̷",
    x: "x̷",
    y: "y̷",
    z: "z̷",
    1: "1̷",
    2: "2̷",
    3: "3̷",
    4: "4̷",
    5: "5̷",
    6: "6̷",
    7: "7̷",
    8: "8̷",
    9: "9̷",
    0: "0̷",
  },
  {
    ا: "آ̲",
    ب: "ب̲",
    و: "ۆ̲",
    ي: "ي̲",
    ث: "ث̲",
    ت: "ت̲",
    خ: "خ̲",
    ج: "ج̲",
    د: "د̲",
    ذ: "ذ̲",
    ز: "ز̲",
    ر: "ر̲",
    س: "س̲",
    ش: "ش̲",
    ص: "ص̲",
    غ: "غ̲",
    ك: "ك̲",
    ف: "ف̲",
    م: "م̲",
    ل: "ل̲",
    ن: "ن̲",
    ه: "ہ̲",
    ح: "ح̲",
    ع: "ع̲",
    ق: "ق̲",
    ط: "ط̲",
    ظ: "ظً̲",
    ى: "ﮯ̲",
    a: "a̲",
    b: "b̲",
    c: "c̲",
    d: "d̲",
    e: "e̲",
    f: "f̲",
    g: "g̲",
    h: "h̲",
    i: "i̲",
    j: "j̲",
    k: "k̲",
    l: "l̲",
    m: "m̲",
    n: "n̲",
    o: "o̲",
    p: "p̲",
    q: "q̲",
    r: "r̲",
    s: "s̲",
    t: "t̲",
    u: "u̲",
    v: "v̲",
    w: "w̲",
    x: "x̲",
    y: "y̲",
    z: "z̲",
    1: "1̲",
    2: "2̲",
    3: "3̲",
    4: "4̲",
    5: "5̲",
    6: "6̲",
    7: "7̲",
    8: "8̲",
    9: "9̲",
    0: "0̲",
  },
  {
    ا: "إآ",
    ب: "̜̌ب",
    و: "ۈ",
    ي: "يَ",
    ث: "ثـ",
    ت: "تـ,",
    خ: "خ",
    ج: "جٍ",
    د: "ﮃ",
    ذ: "ذ",
    ز: "زً",
    ر: "رٍ",
    س: "سًٌُُ",
    ش: "شُ",
    ص: "ص",
    غ: "غ",
    ك: "گ",
    ف: "فَ",
    م: "مـ",
    ل: "لُ",
    ن: "ن",
    ه: "ه̷̸̐",
    ح: "و",
    ع: "۶",
    ق: "ق",
    ط: "طُ",
    ظ: "ظً",
    ى: "ﮯ",
    يا: "يـ/..",
    a: "ɐ",
    b: "p",
    c: "ɔ",
    d: "q",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ı",
    j: "ſ",
    k: "ʞ",
    l: "ן",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "b",
    q: "d",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    1: "⇂",
    2: "Շ",
    3: "Ɛ",
    4: "h",
    5: "ʢ",
    6: "9",
    7: "L",
    8: "8",
    9: "6",
    0: "0",
  },
  {
    ا: "آ̀́",
    ب: "ب̀́",
    و: "ۈ̀́",
    ي: "ي̀́",
    ث: "ث̀́",
    ت: "ت̀́",
    خ: "خ̀́",
    ج: "ج̀́",
    د: "د̀́",
    ذ: "ذ̀́",
    ز: "ز̀́",
    ر: "ر̀́",
    س: "س̀́",
    ش: "ش̀́",
    ص: "ص̀́",
    غ: "غ̀́",
    ك: "ك̀́",
    ف: "ف̀́",
    م: "م̀́",
    ل: "ل̀́",
    ن: "ن̀́",
    ه: "ه̀́",
    ح: "ح̀́",
    ع: "ع̀́",
    ق: "ق̀́",
    ط: "ط̀́",
    ظ: "ظ̀́",
    ى: "ﮯ",
    a: "à́",
    b: "b̀́",
    c: "c̀́",
    d: "d̀́",
    e: "è́",
    f: "f̀́",
    g: "g̀́",
    h: "h̀́",
    i: "ì́",
    j: "j̀́",
    k: "k̀́",
    l: "l̀́",
    m: "m̀́",
    n: "ǹ́",
    o: "ò́",
    p: "p̀́",
    q: "q̀́",
    r: "r̀́",
    s: "s̀́",
    t: "t̀́",
    u: "ù́",
    v: "v̀́",
    w: "ẁ́",
    x: "x̀́",
    y: "ỳ́",
    z: "z̀́",
    1: "1̀́",
    2: "2̀́",
    3: "3̀́",
    4: "4̀́",
    5: "5̀́",
    6: "6̀́",
    7: "7̀́",
    8: "8̀́",
    9: "9̀́",
    0: "0̀́",
  },
  {
    ا: "آ̯͡",
    ب: "ب̯͡",
    و: "ۆ̯͡",
    ي: "ي̯͡",
    ث: "ث̯͡",
    ت: "ت̯͡",
    خ: "خ̯͡",
    ج: "ج̯͡",
    د: "د̯͡",
    ذ: "ذ̯͡",
    ز: "ز̯͡",
    ر: "ر̯͡",
    س: "س̯͡",
    ش: "ش̯͡",
    ص: "ص̯͡",
    غ: "غ̯͡",
    ك: "ك̯͡",
    ف: "ف̯͡",
    م: "م̯͡",
    ل: "ل̯͡",
    ن: "ن̯͡",
    ه: "ہ̯͡",
    ح: "ح̯͡",
    ع: "ع̯͡",
    ق: "ق̯͡",
    ط: "ط̯͡",
    ظ: "ظ̯͡",
    ى: "ﮯ̯͡",
    a: "a̯͡",
    b: "b̯͡",
    c: "c̯͡",
    d: "d̯͡",
    e: "e̯͡",
    f: "f̯͡",
    g: "g̯͡",
    h: "h̯͡",
    i: "i̯͡",
    j: "j̯͡",
    k: "k̯͡",
    l: "l̯͡",
    m: "m̯͡",
    n: "n̯͡",
    o: "o̯͡",
    p: "p̯͡",
    q: "q̯͡",
    r: "r̯͡",
    s: "s̯͡",
    t: "t̯͡",
    u: "u̯͡",
    v: "v̯͡",
    w: "w̯͡",
    x: "x̯͡",
    y: "y̯͡",
    z: "z̯͡",
    1: "1̯͡",
    2: "2̯͡",
    3: "3̯͡",
    4: "4̯͡",
    5: "5̯͡",
    6: "6̯͡",
    7: "7̯͡",
    8: "8̯͡",
    9: "9̯͡",
    0: "0̯͡",
  },
  {
    ا: "آ͠",
    ب: "ب͠",
    و: "و͠",
    ي: "ي͠",
    ث: "ث͠",
    ت: "ت͠",
    خ: "خ͠",
    ج: "ج͠",
    د: "د͠",
    ذ: "ذ͠",
    ز: "ز͠",
    س: "س͠",
    ش: "ش͠",
    ص: "ص͠",
    ع: "ع͠",
    ك: "گ͠",
    ف: "ف͠",
    م: "م͠",
    ل: "ل͠",
    ن: "ن͠",
    ه: "ه͠",
    ح: "ح͠",
    غ: "غ͠",
    ق: "ق͠",
    ط: "ط͠",
    ظ: "ظ͠",
    ى: "ے͠",
    1: "1͠",
    2: "2͠",
    3: "3͠",
    4: "4͠",
    5: "5͠",
    6: "6͠",
    7: "7͠",
    8: "8͠",
    9: "9͠",
    0: "0͠",
    a: "a͠",
    b: "b͠",
    c: "c͠",
    d: "d͠",
    e: "e͠",
    f: "f͠",
    g: "g͠",
    h: "h͠",
    i: "i͠",
    j: "j͠",
    k: "k͠",
    l: "l͠",
    m: "m͠",
    n: "n͠",
    o: "o͠",
    p: "p͠",
    q: "q͠",
    r: "r͠",
    s: "s͠",
    t: "t͠",
    u: "u͠",
    v: "v͠",
    w: "w͠",
    x: "x͠",
    y: "y͠",
    z: "z͠",
  },
  {
    ا: "آإ",
    ب: "بـ♥̨̥̬̩",
    و: "و",
    ي: "ي",
    ث: "ثـ♥̨̥̬̩",
    ت: "تـ♥̨̥̬̩",
    خ: "خ",
    ج: "جـ♥̨̥̬̩",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "س",
    ش: "ش",
    ص: "ص",
    ع: "ع",
    ك: "گ♥̨̥̬̩",
    ف: "ف",
    م: "مـ♥̨̥̬̩",
    ل: "ل",
    ن: "ن",
    ه: "هـ♥̨̥̬̩",
    ح: "حـ♥̨̥̬̩",
    غ: "غ♥̨̥̬̩",
    ق: "قـ♥̨̥̬̩",
    ط: "ط♥̨̥̬̩",
    ظ: "ظ♥̨̥̬̩",
    ى: "ے",
    1: "¹",
    2: "²",
    3: "³",
    4: "⁴",
    5: "⁵",
    6: "⁶",
    7: "⁷",
    8: "⁸",
    9: "⁹",
    0: "⁰",
    a: "ᴬ",
    b: "ᴮ",
    c: "ᶜ",
    d: "ᴰ",
    e: "ᴱ",
    f: "ᶠ",
    g: "ᴳ",
    h: "ᴴ",
    i: "ᴵ",
    j: "ᴶ",
    k: "ᴷ",
    l: "ᴸ",
    m: "ᴹ",
    n: "ᴺ",
    o: "ᴼ",
    p: "ᴾ",
    q: "ᵠ",
    r: "ᴿ",
    s: "ˁ",
    t: "ᵀ",
    u: "ᵁ",
    v: "ᵛ",
    w: "ᵂ",
    x: "ˣ",
    y: "ʸ",
    z: "ᶻ",
  },
  {
    ا: "آ",
    ب: "بـٌـٌٌـٌٌٌـٌٌـٌ",
    و: "وُ",
    ي: "ي",
    ث: "ثُ",
    ت: "تـٌـٌٌـ",
    خ: "ځـٌٌـٌٌ",
    ج: "جـ,ـ",
    د: "ڊ",
    ذ: "ڏ",
    ز: "ڒٍ",
    س: "ڛـ,ـ",
    ش: "شُـُـُُـُ",
    ص: "صُـ,ـ",
    غ: "غٍـُـُُـُُُـُُُُـُُُـُُـُ",
    ك: "كُـُ",
    ف: "فُـ,ـ",
    م: "مـْـْْـْ",
    ل: "لُـِـِِـِِِـِِـِـ",
    ن: "نـِِـِـ",
    ه: "ﮩ",
    ح: "حـًـًًـًًًـًًـًـ",
    ع: "عٌـِـِِـِـ",
    ق: "قٌـ,ـ",
    ط: "طُـٌـٌٌـٌ",
    ظ: "ظً",
    ى: "ﮯ",
    1: "(̲̅1̲̅)",
    2: "(̲̅2̲̅)",
    3: "(̲̅3̲̅)",
    4: "(̲̅4̲̅)",
    5: "(̲̅5̲̅)",
    6: "(̲̅6̲̅)",
    7: "(̲̅7̲̅)",
    8: "(̲̅8̲̅)",
    9: "(̲̅9̲̅)",
    0: "(̲̅0̲̅)",
    a: "(̲̅a̲̅)",
    b: "(̲̅b̲̅)",
    c: "(̲̅c̲̅)",
    d: "(̲̅d̲̅)",
    e: "(̲̅e̲̅)",
    f: "(̲̅f̲̅)",
    g: "(̲̅g̲̅)",
    h: "(̲̅h̲̅)",
    i: "(̲̅i̲̅)",
    j: "(̲̅j̲̅)",
    k: "(̲̅k̲̅)",
    l: "(̲̅l̲̅)",
    m: "(̲̅m̲̅)",
    n: "(̲̅n̲̅)",
    o: "(̲̅o̲̅)",
    p: "(̲̅p̲̅)",
    q: "(̲̅q̲̅)",
    r: "(̲̅r̲̅)",
    s: "(̲̅s̲̅)",
    t: "(̲̅t̲̅)",
    u: "(̲̅u̲̅)",
    v: "(̲̅v̲̅)",
    w: "(̲̅w̲̅)",
    x: "(̲̅x̲̅)",
    y: "(̲̅y̲̅)",
    z: "(̲̅z̲̅)",
  },
  {
    ا: "ا",
    ب: "ب",
    و: "و",
    ي: "يہ",
    ث: "ثہ",
    ت: "تہ",
    خ: "خہ",
    ج: "جہ",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہ",
    ش: "شہ",
    ص: "ص",
    غ: "غہ",
    ك: "كُہ",
    ف: "فُہ",
    م: "م",
    ل: "لہ",
    ن: "ن",
    ه: "ه",
    ح: "حہ",
    ع: "عہ",
    ق: "ق",
    ط: "طہ",
    ظ: "ظ",
    ى: "ي",
    1: "1",
    2: "2ً",
    3: "3ً",
    4: "4ً",
    5: "5ً",
    6: "6ً",
    7: "7َ",
    8: "8ً",
    9: "9ً",
    0: "0ً",
    a: "ä",
    b: "þ",
    c: "c",
    d: "ḑ",
    e: "ễ",
    f: "f",
    g: "g",
    h: "ħ",
    i: "ī",
    j: "Ĵ",
    k: "Ķ",
    l: "l",
    m: "m",
    n: "ٍñ",
    o: "o",
    p: "p",
    q: "q",
    r: "r",
    s: "ṩ",
    t: "Ť",
    u: "ú",
    v: "v",
    w: "‏w ",
    x: "x",
    y: "ÿ",
    z: "ź",
  },
  {
    ا: "أ",
    ب: "بہ",
    و: "و",
    ي: "يہ",
    ث: "ثہ",
    ت: "تہ",
    خ: "خہ",
    ج: "جہ",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہ",
    ش: "شہ",
    ص: "صہ",
    غ: "غہ",
    ك: "كہ",
    ف: "فہ",
    م: "مہ",
    ل: "ل",
    ن: "نہ",
    ه: "ه",
    ح: "حہ",
    ع: "عہ",
    ق: "قہ",
    ط: "طہ",
    ظ: "ظہ",
    ي: "يہ",
    a: "ặ",
    b: "ß",
    c: "c",
    d: "d",
    e: "ě",
    f: "f",
    g: "g",
    h: "ĥ",
    i: "í",
    j: "j",
    k: "k",
    l: "ł ",
    m: "ɱ",
    n: "ŋ",
    o: "ŏ",
    p: "p",
    q: "q",
    r: "ř",
    s: "ś",
    t: "ț",
    u: "u",
    v: "v",
    w: "w",
    x: "x",
    y: "ŷ",
    z: "ž",
    A: "ֻ",
    B: "ג",
    C: "Ͼ",
    D: "׀",
    E: "׃",
    F: "Ḟ",
    G: "Ḡ",
    H: "Ḥ",
    I: "ḭ",
    J: "J",
    K: "Ḳ",
    L: "Ɫ",
    M: "Ṃ",
    N: "Ṇ",
    O: "Ṓ",
    P: "Ᵽ",
    Q: "Q",
    R: "Ṝ",
    S: "Ṩ",
    T: "Ṫ",
    U: "Ṷ",
    V: "Ṿ",
    W: "Ẅ",
    X: "Ẍ",
    Y: "Ῡ",
    Z: "Ẓ",
  },
  {
    ا: "ا",
    ب: "بٰٰ",
    و: "و",
    ي: "يٰ",
    ث: "ثہٰـ",
    ت: "تہٰ",
    خ: "خ",
    ج: "ج",
    د: "د",
    ذ: "ذ",
    ز: "ز",
    س: "سہٰ",
    ش: "ش",
    ص: "صہٰ",
    ع: "ع",
    ك: "كہٰ",
    ف: "فہٰ",
    م: "م",
    ل: "لہٰ",
    ن: "ن",
    ه: "ه",
    ح: "حہٰ",
    غ: "غ",
    ق: "ق",
    ط: "طہٰ",
    ظ: "ظ",
    ى: "ي",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    0: "0",
    a: "Ꭿ ",
    b: "Ᏸ ",
    c: "Ꮸ",
    d: "Ꭰ",
    e: "Ꭼ",
    f: "Ꮀ",
    g: "Ꮆ",
    h: "Ꮋ",
    i: "Ꭵ",
    j: "Ꭻ",
    k: "Ꮶ",
    l: "Ꮮ",
    m: "Ꮇ",
    n: "Ꮑ",
    o: "Ꮻ",
    p: "Ꮲ",
    q: "Ꮕ",
    r: "Ꭱ",
    s: "Ꮪ",
    t: "Ꮏ",
    u: "Ꮜ",
    v: "Ꮙ",
    w: "Ꮤ",
    x: "X",
    y: "Ꮍ",
    z: "Ꮓ",
  },
  {
    ا: "آ",
    ب: "بَ",
    و: "وُ",
    ي: "ي",
    ث: "ث",
    ت: "ت",
    خ: "خـ",
    ج: "جٍ",
    د: "دِ",
    ذ: "ذَ",
    ز: "زْ",
    ر: "رٍ",
    س: "س",
    ش: "شُ",
    ص: "ص",
    غ: "غ",
    ك: "ڪ",
    ف: "فُ",
    م: "م",
    ل: "لُِ",
    ن: "ن",
    ه: "هـ",
    ح: "حٍ",
    ع: "عٍ",
    ق: "قٌ",
    ط: "طُ",
    ظ: "ظً",
    ى: "ﮯ",
    a: "a",
    b: "b",
    c: "ç",
    d: "ƌ̲̣̣̣̥",
    e: "e̲̣̥",
    f: "ƒ",
    g: "Ǧ̩̥",
    h: "h",
    i: "ɪ̣̝̇",
    j: "Ĵ",
    k: "k",
    l: "l",
    m: "m̥",
    n: "n̥̥̲̣̥",
    o: "ọ̥",
    p: "ٌ̥̥",
    q: "ợ",
    r: "ے̲̣̣̥",
    s: "ƨ",
    t: "ô̲̣̣̥",
    u: "u",
    v: "ُ̲̣̥",
    w: "‏",
    x: "x̲̣̣̣̥",
    y: "y̥",
    z: "z̲̣̥",
    1: "1̣̣̝̇̇",
    2: "2̲̣̣̣̥",
    3: "3̍̍̍̊",
    4: "4̩̥",
    5: "5̲̣̥",
    6: "6̲̣̣̣̥",
    7: "7̲̣̣̣̥",
    8: "8̥̥̥̥̥̥̥̥̥̥̥̥",
    9: "9̲̣̣̣̥",
    0: "0̲̣̣̣̥",
    A: "Λ",
    B: "β",
    C: "C",
    D: "D",
    E: "Σ",
    F: "F",
    G: "G",
    H: "H",
    I: "I",
    J: "J",
    K: "K",
    L: "L",
    M: "M",
    N: "П",
    O: "Ф",
    P: "P",
    Q: "Q",
    R: "Я",
    S: "S",
    T: "T",
    U: "Ц",
    V: "V",
    W: "W",
    X: "X",
    Y: "Y",
    Z: "Z",
  },
  {
    ا: "آ",
    ب: "بَ",
    و: "وُ",
    ي: "ي",
    ث: "ث",
    ت: "ت",
    خ: "خـ",
    ج: "جٍ",
    د: "دِ",
    ذ: "ذَ",
    ز: "زْ",
    ر: "رٍ",
    س: "س",
    ش: "شُ",
    ص: "ص",
    غ: "غ",
    ك: "ڪ",
    ف: "فُ",
    م: "م",
    ل: "لُِ",
    ن: "ن",
    ه: "هـ",
    ح: "حٍ",
    ع: "عٍ",
    ق: "قٌ",
    ط: "طُ",
    ظ: "ظً",
    ى: "ﮯ",
    a: "a",
    b: "b",
    c: "ç",
    d: "ƌ̲̣̣̣̥",
    e: "e̲̣̥",
    f: "ƒ",
    g: "Ǧ̩̥",
    h: "h",
    i: "ɪ̣̝̇",
    j: "Ĵ",
    k: "k",
    l: "l",
    m: "m̥",
    n: "n̥̥̲̣̥",
    o: "ọ̥",
    p: "ٌ̥̥",
    q: "ợ",
    r: "ے̲̣̣̥",
    s: "ƨ",
    t: "ô̲̣̣̥",
    u: "u",
    v: "ُ̲̣̥",
    w: "‏",
    x: "x̲̣̣̣̥",
    y: "y̥",
    z: "z̲̣̥",
    1: "1̣̣̝̇̇",
    2: "2̲̣̣̣̥",
    3: "3̍̍̍̊",
    4: "4̩̥",
    5: "5̲̣̥",
    6: "6̲̣̣̣̥",
    7: "7̲̣̣̣̥",
    8: "8̥̥̥̥̥̥̥̥̥̥̥̥",
    9: "9̲̣̣̣̥",
    0: "0̲̣̣̣̥",
    A: "Λ",
    B: "β",
    C: "C",
    D: "D",
    E: "Σ",
    F: "F",
    G: "G",
    H: "H",
    I: "I",
    J: "J",
    K: "K",
    L: "L",
    M: "M",
    N: "П",
    O: "Ф",
    P: "P",
    Q: "Q",
    R: "Я",
    S: "S",
    T: "T",
    U: "Ц",
    V: "V",
    W: "W",
    X: "X",
    Y: "Y",
    Z: "Z",
  },
  {
    a: "ɒ",
    b: "d",
    c: "ɔ",
    d: "b",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ᴉ",
    j: "ɾ",
    k: "ʞ",
    l: "ʃ",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "d",
    q: "b",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    A: "∀",
    B: "𐐒",
    C: "Ↄ",
    D: "◖",
    E: "Ǝ",
    F: "Ⅎ",
    G: "⅁",
    H: "H",
    I: "I",
    J: "ſ",
    K: "ʞ",
    L: "⅃",
    M: "W",
    N: "ᴎ",
    O: "O",
    P: "Ԁ",
    Q: "Ὁ",
    R: "ᴚ",
    S: "S",
    T: "⊥",
    U: "∩",
    V: "Λ",
    W: "M",
    X: "X",
    Y: "⅄",
    Z: "Z",
    1: "Ɩ",
    2: "ᄅ",
    3: "Ɛ",
    4: "ㄣ",
    5: "ϛ",
    6: "9",
    7: "ㄥ",
    8: "8",
    9: "6",
    0: "0",
  },
  {
    a: "ɐ",
    b: "q",
    c: "ɔ",
    d: "p",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ᴉ",
    j: "ɾ",
    k: "ʞ",
    l: "ן",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "d",
    q: "b",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    A: "∀",
    B: "𐐒",
    C: "Ↄ",
    D: "◖",
    E: "Ǝ",
    F: "Ⅎ",
    G: "⅁",
    H: "H",
    I: "I",
    J: "ſ",
    K: "ʞ",
    L: "⅃",
    M: "W",
    N: "ᴎ",
    O: "O",
    P: "Ԁ",
    Q: "Ὁ",
    R: "ᴚ",
    S: "S",
    T: "⊥",
    U: "∩",
    V: "Λ",
    W: "M",
    X: "X",
    Y: "⅄",
    Z: "Z",
    1: "Ɩ",
    2: "ᄅ",
    3: "Ɛ",
    4: "ㄣ",
    5: "ϛ",
    6: "9",
    7: "ㄥ",
    8: "8",
    9: "6",
    0: "0",
  },
  {
    a: "ɑ",
    b: "ᶀ",
    c: "ↄ",
    d: "ᵭ",
    e: "ɛ",
    f: "ʇ",
    g: "ɠ",
    h: "ɦ",
    i: "ı",
    j: "ſ",
    k: "ʞ",
    l: "ˡ",
    m: "ɱ",
    n: "ɲ",
    o: "ơ",
    p: "ρ",
    q: "ɋ",
    r: "ɹ",
    s: "ȿ",
    t: "ʈ",
    u: "ʋ",
    v: "ʌ",
    w: "ʍ",
    x: "χ",
    y: "ɣ",
    z: "ȥ",
    A: "α",
    B: "β",
    C: "χ",
    D: "δ",
    E: "ε",
    F: "ϝ",
    G: "γ",
    H: "η",
    I: "ι",
    J: "ϑ",
    K: "κ",
    L: "λ",
    M: "μ",
    N: "ν",
    O: "ο",
    P: "π",
    Q: "ϙ",
    R: "ρ",
    S: "ς",
    T: "τ",
    U: "υ",
    V: "ϖ",
    W: "ω",
    X: "χ",
    Y: "ψ",
    Z: "ζ",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    0: "0",
  },
  {
    a: "ɒ",
    b: "d",
    c: "ɔ",
    d: "b",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ᴉ",
    j: "ɾ",
    k: "ʞ",
    l: "ʃ",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "d",
    q: "b",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    A: "∀",
    B: "𐐒",
    C: "Ↄ",
    D: "◖",
    E: "Ǝ",
    F: "Ⅎ",
    G: "⅁",
    H: "H",
    I: "I",
    J: "ſ",
    K: "ʞ",
    L: "⅃",
    M: "W",
    N: "ᴎ",
    O: "O",
    P: "Ԁ",
    Q: "Ὁ",
    R: "ᴚ",
    S: "S",
    T: "⊥",
    U: "∩",
    V: "Λ",
    W: "M",
    X: "X",
    Y: "⅄",
    Z: "Z",
    1: "Ɩ",
    2: "ᄅ",
    3: "Ɛ",
    4: "ㄣ",
    5: "ϛ",
    6: "9",
    7: "ㄥ",
    8: "8",
    9: "6",
    0: "0",
  },
  {
    a: "ɐ",
    b: "q",
    c: "ɔ",
    d: "p",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ᴉ",
    j: "ɾ",
    k: "ʞ",
    l: "ן",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "d",
    q: "b",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    A: "∀",
    B: "𐐒",
    C: "Ↄ",
    D: "◖",
    E: "Ǝ",
    F: "Ⅎ",
    G: "⅁",
    H: "H",
    I: "I",
    J: "ſ",
    K: "ʞ",
    L: "⅃",
    M: "W",
    N: "ᴎ",
    O: "O",
    P: "Ԁ",
    Q: "Ὁ",
    R: "ᴚ",
    S: "S",
    T: "⊥",
    U: "∩",
    V: "Λ",
    W: "M",
    X: "X",
    Y: "⅄",
    Z: "Z",
    1: "Ɩ",
    2: "ᄅ",
    3: "Ɛ",
    4: "ㄣ",
    5: "ϛ",
    6: "9",
    7: "ㄥ",
    8: "8",
    9: "6",
    0: "0",
  },
];
function TextDecorator() {
  const getPaddingRight = () => {
    if (window.innerWidth <= 768) {
      return "90px";
    }
    return "150px";
  };
  const style = {
    paddingRight: getPaddingRight(),
  };
  const [inputText, setInputText] = useState("");
  const [decoratedTexts, setDecoratedTexts] = useState([]);
  const defaultPreviewText = "نص مزخرف";
  useEffect(() => {
    generateDecoratedTexts(inputText || defaultPreviewText);
  }, [inputText]);
  const handleInputChange = (event) => {
    const text = event.target.value;
    setInputText(text);
  };
  const generateDecoratedTexts = (text) => {
    if (!text) {
      setDecoratedTexts([]);
      return;
    }
    const decorated = flipTables.map((table) => {
      return text
        .split("")
        .map((char) => table[char] || char)
        .join("");
    });
    setDecoratedTexts(decorated);
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("تم النسخ إلى الحافظة!");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقدم أداة زخرفة النصوص لدينا طريقة بسيطة وفعالة لتحويل الأسماء
                  والحروف إلى أشكال مزخرفة باللغة العربية والإنجليزية. باستخدام
                  هذه الأداة، يمكنك تزيين نصوصك بطرق مختلفة لجعلها أكثر جاذبية
                  وتميزًا. اختر من بين مجموعة واسعة من الأنماط والخطوط والرموز
                  لتخصيص النصوص الخاصة بك، سواء كانت باللغة العربية أو
                  الإنجليزية.
                </p>
                <p>
                  <strong>زخرفة أسماء باللغة العربية والإنجليزية:</strong> توفر
                  لك الأداة إمكانيات متعددة لتزيين الأسماء والحروف، مما يجعلها
                  مثالية للاستخدام في صفحات التواصل الاجتماعي، المدونات،
                  والتصاميم الجرافيكية. يمكنك بسهولة إدخال الاسم أو النص
                  المطلوب، واختيار الزخرفة التي تناسب ذوقك، ثم نسخ النص المزخرف
                  لاستخدامه في أي مكان تريده.
                </p>
                <p>
                  <strong>استخدامات زخرفة النصوص:</strong> يمكن استخدام الأداة
                  لخلق تأثيرات زخرفية جذابة للنصوص في منشورات وسائل التواصل
                  الاجتماعي، التصاميم الفنية، التوقيعات الرقمية، وأي تطبيقات
                  أخرى تتطلب تزيين النصوص. استمتع بإنشاء تصاميم نصية مميزة مع
                  زخارف جميلة تناسب جميع الأذواق.
                </p>
                <p>
                  <strong>ميزات الأداة:</strong>- زخرفة أسماء وحروف باللغة
                  العربية والإنجليزية - مجموعة متنوعة من الأنماط والخطوط - سهولة
                  الاستخدام والتخصيص - إمكانية استخدام الزخارف في أي مجال من
                  مجالات التصميم والتواصل
                </p>
                <p>
                  استخدم أداة زخرفة النصوص لدينا لتحويل نصوصك إلى تصاميم رائعة
                  تعكس ذوقك وتضيف لمسة من الإبداع إلى مشاريعك.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  إدخال النص المراد زخرفته
                </div>
                <hr />
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    value={inputText}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="أدخل هنا النص المراد زخرفته"
                  />
                </div>
                <br />
                <hr />
              </div>
              <div className="col-12 col-md-7">
                <div>
                  <h4>النص المزخرف:</h4>
                  <hr />
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                    }}
                  >
                    {decoratedTexts.length > 0 ? (
                      decoratedTexts.map((text, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "10px",
                            marginBottom: "10px",
                            borderRadius: "4px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <span>{text}</span>
                            <div style={style}>
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => copyToClipboard(text)}
                                style={{
                                  alignItems: "flex-end",
                                }}
                              >
                                نسخ
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>أدخل النص لعرض الزخرفة</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              كيفية استخدام أداة زخرفة النصوص؟
            </div>
            <div className="info-section-body">
              <p>لاستخدام أداة زخرفة النصوص، اتبع الخطوات التالية:</p>
              <ol>
                <li>
                  قم بإدخال النص الذي ترغب في تزيينه في الحقل المخصص أعلى
                  الصفحة.
                </li>
                <li>
                  اختر من بين مجموعة متنوعة من الأنماط والخطوط المتاحة. ستجد
                  خيارات تشمل تصاميم زخرفية متعددة تناسب النصوص العربية
                  والإنجليزية.
                </li>
                <li>
                  قم بمراجعة النص المزخرف الذي يظهر في أسفل الصفحة. يمكنك رؤية
                  التغييرات مباشرة بعد اختيار الأنماط المختلفة.
                </li>
                <li>
                  انسخ النص المزخرف بنقرة واحدة على زر "نسخ" لاستخدامه في أي
                  تطبيق تريده، مثل منشورات وسائل التواصل الاجتماعي، التوقيعات
                  الرقمية، أو تصاميم الجرافيك.
                </li>
              </ol>
              <p>
                مثال: إذا كنت ترغب في تزيين اسمك "أحمد" بخطوط مزخرفة، أدخله في
                الحقل، ثم اختر نمط الزخرفة الذي تفضله، وستتمكن من الحصول على
                نتائج مزخرفة وجذابة بسرعة وسهولة.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              ما هي أداة زخرفة النصوص؟
            </div>
            <div className="info-section-body">
              <p>
                أداة زخرفة النصوص هي أداة متقدمة تتيح لك تزيين النصوص والأسماء
                بأنماط وخطوط متنوعة لخلق تصاميم جذابة وفريدة. سواء كنت ترغب في
                تزيين النصوص باللغة العربية أو الإنجليزية، توفر الأداة خيارات
                متعددة لتخصيص النصوص بطرق إبداعية.
              </p>
              <p>
                تتضمن الأداة مجموعة من الأنماط الزخرفية المختلفة التي تشمل
                خطوطاً مزخرفة ورموزاً خاصة. يمكنك الاختيار من بين هذه الأنماط
                لإضفاء لمسة جمالية على نصوصك، مما يجعلها مثالية للاستخدام في
                المنشورات على وسائل التواصل الاجتماعي، التصميمات الجرافيكية،
                والمزيد.
              </p>
              <p>
                مثال: إذا كنت ترغب في زخرفة اسم "Sara" بخطوط أنيقة، يمكنك
                استخدام الأداة لاختيار نمط زخرفي يبرز الاسم بطريقة جذابة، مما
                يجعله مميزاً في تصاميمك الجرافيكية أو منصات التواصل الاجتماعي.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TextDecorator;
